module.exports = __webpack_public_path__ + "aa00880030832041e392da30ac043ac9.jpg";